<<!-- api页面 -->
<template>
  <div class="fz-14 line-14 text-l pb-40">
    <!-- 未获取apikey -->
    <div v-if="status==1">
      <el-row class="c-000 fz-1 line-22 fz-14 mt-24 mb-20">API接口</el-row>
      <el-row>您还未申请Apikey，无需在首页认证，请点击下方按钮即可获得Apikey。</el-row>
      <el-row class="mt-20 mb-20">
        <el-button type="primary" @click="setAppKey">申请APIKEY</el-button>
      </el-row>
      <el-row class="c-000 fz-14 line-22 mb-20 mt-44">内容为王！共享优质大数据，帮助开发者构建优质内容</el-row>
      <el-row>
        <span class="c-ea4">本功能仅面向有技术基础的开发者</span>
        <span>,更多信息查看</span>
        <span class="c-ea4 pointer" @click="goApitable(1)">【API接口文档】</span>
      </el-row>
    </div>
    <div class="center" v-if="status==2">
      <el-row>
        <img src="../../assets/api/gongxi.png" class="gonxi">
      </el-row>
      <el-row class="fz-14 c-000 line-22">API</el-row>
      <el-row class="line-22 c-c0c">已免费开通</el-row>
      <el-row class="mt-18 mb-80">
        <el-button type="primary" @click="goList">立即使用</el-button>
      </el-row>
    </div>
    <!-- 文档列表 -->
    <div v-if="status==3">
      <!-- <el-row class="c-000 fz-1 line-22 fz-14 mt-24 mb-20">API接口</el-row> -->
      <el-row class="mb-20 mt-20">
        
        <span>本功能仅面向有技术基础的开发者，更多信息查看</span>
        <span class="c-e12 pointer" @click="goApitable(1)">【API接口文档】</span>
      </el-row>
      <el-row class="line-60 b-f5f radius-2">
        <span class="ml-4">您的APIKEY：</span>
        <span class="c-e12">{{apikey}}</span>
        <span>请勿泄漏您的APIKEY以免被恶意使用</span>
        <el-button class="ml-10" type='primary'  @click="resetApikey">重置</el-button>
      </el-row>
      <!-- <el-row class="c-000 fz-1 line-22 fz-14 mt-24 mb-20">可调用API接口</el-row> -->
      <el-row>
        <!-- <template> -->
          <!-- <el-table :data="arr" stripe style="width:100%">
            <el-table-column prop="title" label="API名称" width="180"></el-table-column>
            <el-table-column prop="type" label="方法" width="60"></el-table-column>
            <el-table-column label="返回数据类型" width="100">json数据类型</el-table-column>
            <el-table-column label="请求示例" min-width="380">
              <template slot-scope="scope">
                <el-link type="primary" class='' :href="scope.row.url" target="_blank">{{scope.row.url}}</el-link>
              </template>
            </el-table-column>
            <el-table-column label="操作" width='130px'>
              <template slot-scope="scope">
                <div class='xiangxi' @click="goApitable(2,scope.row.doc)" plain>详细调用文档</div>
              </template>
            </el-table-column>
          </el-table> -->
        <!-- </template> -->
      </el-row>
    </div>
    <!-- 弹框提示 -->
    <el-dialog title="操作提示" :visible.sync="dialog" width="30%">
      <div class="line-22">重置后请使用新的APIKEY</div>
      <div class="fz-14 line-20 mt-20 c-e53">*1小时内只允许重置1次；</div>
      <div class="fz-14 line-14 c-e53">*旧的APIKEY将在1小时后失效；</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="aginAppKey">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 1小时 -->
    <el-dialog title="操作提示" :visible.sync="agin" width="30%">
      <div class="line-22">1小时内只允许重置1次APIKETY</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="agin=false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import "./tool.css";
export default {
  name: "api",
  data() {
    return {
      api: {
        getUserInfo: "/home/getUserInfo", //检测apikey
        setAppKey: "/home/setAppKey", //生成或生成新的appKey
        apiList: "/home/apiList" //获取api列表
      },
      status: "",
      apikey: "", //apikey
      dialog: false,
      agin: false,
      arr: []
    };
  },
  components: {},
  created() {
    this.getUserInfo();
    this.apiList();
  },
  mounted() {},
  methods: {
    getUserInfo() {
      let _this = this;
      let data = {};
      _this
        .$http({
          method: "GET",
          url: _this.api.getUserInfo,
          params: data
        })
        .then(res => {
          if (res.code == 1) {
            if (res.data.app_key) {
              _this.status = 3;
              _this.apikey = res.data.app_key;
            } else {
              _this.status = 1;
            }
          } else {
            console.log(res.msg);
          }
        });
    },
    setAppKey() {
      //生成或生成新的appKey
      let _this = this;
      let data = {};
      _this
        .$http({
          method: "POST",
          url: _this.api.setAppKey,
          data: {}
        })
        .then(res => {
          if (res.code == 1) {
            _this.status = 2;
            _this.apikey = res.data;
          } else {
            this.$message({
              message: res.msg,
              type: "warning"
            });
          }
          console.log(res);
        });
    },
    goList() {
      //立即使用
      this.status = 3;
      this.apiList();
    },
    resetApikey() {
      //重置apikey
      let _this = this;
      _this.dialog = true;
    },
    aginAppKey() {
      let _this = this;
      let data = {};
      _this
        .$http({
          method: "POST",
          url: _this.api.setAppKey,
          data: {}
        })
        .then(res => {
          if (res.code == 1) {
            _this.apikey = res.data;
            this.$message({
              message: "重置成功",
              type: "success"
            });
            _this.apiList();
            _this.dialog = false;
          } else {
            if (res.data == "修改过于频繁，请稍后再试") {
              _this.agin = true;
            } else {
              this.$message({
                message: res.data,
                type: "warning"
              });
            }
          }
        });
    },
    apiList() {
      //api列表
      let _this = this;
      _this
        .$http({
          method: "GET",
          url: _this.api.apiList,
          params: {}
        })
        .then(res => {
          if (res.code == 1) {
            _this.arr = res.data;
          } else {
            console.log(res.msg);
          }
        });
    },
    goApitable(num, url) {
      //去到开放平台
      if (num == 1) {
        window.open("https://openapi.linkstars.com/doc/home/");
      } else if (num == 2) {
        window.open(url);
      }
    }
  }
};
</script>
<style  scoped>
.radius-2 {
  border-radius: 2px;
}
.gonxi {
  margin-top: 120px;
}
.xiangxi{
  width:104px;
  height:32px;
  border-radius:2px;
  background:#ededed;
  color:#999;
  cursor: pointer;
  text-align: center;
  line-height:32px;
}
.xiangxi:hover{
  background-color:#6435E8;
  color:#fff;
}
</style>